import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatTable } from '@angular/material';
import { CaseManagementService } from 'src/app/core/services/v2/case-management.service';
import { WindowLoaderService } from 'src/app/shared/components/window-loader/window-loader.service';
import { Case } from '../../models/casehistory';
import { NursingNote } from '../../models/nursingNote';
import { AddnoteDialogComponent } from './addnote-dialog/addnote-dialog.component';


@Component({
  selector: 'nursing-note',
  templateUrl: './nursing-note.component.html',
  styleUrls: ['./nursing-note.component.scss']
})
export class NursingNoteComponent implements OnInit {
  @Input() caseModel: Case;
  @Output() toggleEvent = new EventEmitter();
nursingNotes:NursingNote[]=[];

  ngOnInit() {
    this.getNotes();
  }

  // @ViewChild(MatTable,{static:true}) table: MatTable<any>;

  constructor(public dialog: MatDialog,
    private loaderService: WindowLoaderService,
    private caseManagementService:CaseManagementService
    ) {}

  openDialog(action,obj:NursingNote) {
    if(obj==null){
obj=new NursingNote();
obj.caseId=this.caseModel.id;
    }
    const dialogRef = this.dialog.open(AddnoteDialogComponent, {
      width: '750px',
      data:{action:action,caseNursingNote:obj}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.getNotes();
    //   if(result.event == 'Add'){
    //     this.addRowData(result.caseNursingNote);
    //   }else if(result.event == 'Update'){
    //     this.updateRowData(result.data);
    //   }else if(result.event == 'Delete'){
    //     this.deleteRowData(result.data);
    //   }
    // });
    });
  }

  addRowData(row_obj){
    this.nursingNotes.concat(row_obj)
    this.getNotes();
  }
  updateRowData(row_obj){
    // this.dataSource = this.dataSource.filter((value,key)=>{
    //   if(value.id == row_obj.id){
    //     value.name = row_obj.name;
    //   }
    //   return true;
    // });
  }
  deleteNursingNote(row_obj){
    
    this.loaderService.show();
    this.caseManagementService
      .deleteNursingNote(
        row_obj.id
      )
      .subscribe((res) => {
        this.getNotes()
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
    
  }
  getNotes(){
    this.loaderService.show();
    this.caseManagementService
      .getCaseNursingNotes(
        this.caseModel.id
      )
      .subscribe((res) => {
        this.nursingNotes=res.result;
        this.loaderService.hide();

      }, (error) => {
        console.error(error);
        this.loaderService.hide();
      },
      () => {
        this.loaderService.hide();
      });
  }

}
